import {Routes} from '@angular/router';
import {ModelEditorComponent} from "@catmodules/model-editor/components/model-editor.component";

export const routes: Routes = [
  {
    path: '**',
    component: ModelEditorComponent
  },
];



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/model-editor/model-editor.routing.ts